let utmkeeper = {};

(function (context) {
  let config = {
    // override page utms with the url utms
    forceOriginUTM: true,
    // fill page forms with the url utms
    fillForms: true,
    // starting utm object to start the parsing with a custom set of utms
    utmObject: {},
    // post load function that receives a object as parameter
    // to run custom logic after utm processing. Example:
    // function(utms) {
    //   console.log(utms);
    // }
    postLoad: null,
  };

  context.extractUrlParams = function (url = '') {
    // get query string from url (optional) or window
    let queryString = '';

    if (url) {
      let urlSplit = url.split('?');

      if (urlSplit.length > 1) {
        queryString = url.split('?')[1];
      } else {
        queryString = url.split('?')[0];
      }
    } else {
      queryString = window.location.search.slice(1);
    }

    // we'll store the parameters here
    let obj = {};

    // if query string exists
    if (queryString) {
      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      let arr = queryString.split('&');

      for (let i = 0; i < arr.length; i++) {
        // separate the keys and the values
        let a = arr[i].split('=');

        let paramName = a[0];

        // set parameter value (use 'true' if empty)
        let paramValue = typeof a[1] === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        if (typeof paramName === 'string') {
          paramName = paramName.toLowerCase();
        }

        if (typeof paramValue === 'string') {
          paramValue = unescape(paramValue).toLowerCase();
        }

        // extract only if matches the filter and has value
        if (paramValue) {
          obj[paramName] = paramValue;
        }
      }
    }

    return obj;
  };

  context.toUrlSearch = function (obj) {
    let searchUrl = '';

    for (let key in obj) {
      if (!obj[key]) {
        continue;
      }
      if (searchUrl != '') {
        searchUrl += '&';
      }

      // if its string set the parameter
      if (typeof obj[key] === 'string') {
        searchUrl += key + '=' + encodeURIComponent(obj[key]);
      }
      // if not string serialize as url array
      else {
        for (let i = 0; i < obj[key].length; i++) {
          if (i > 0) {
            searchUrl += '&';
          }

          searchUrl += key + '[' + i.toString() + ']=' + encodeURIComponent(obj[key][i]);
        }
      }
    }

    return searchUrl;
  };

  function getCtaId(link) {
    if (link && link.dataset && link.dataset.gaAction && link.dataset.gaAction !== 'city_click') {
      return link.dataset.gaAction;
    }
    return '';
  }

  function applyUtmOnAttribute(config, originSearchObj, link, attrName) {
    const attributeValue = link.getAttribute(attrName);
    if (!attributeValue) {
      return;
    }

    let urlParams = context.extractUrlParams(attributeValue);
    if (!Object.keys(urlParams).length) {
      return;
    }

    let base = '', search = '', hash = '', href = '';
    // extract it hash block
    let attrSplit = attributeValue.split('#');
    if (attrSplit.length > 1) {
      hash = attrSplit[1];
    }
    // extract search block
    attrSplit = attrSplit[0].split('?');
    if (attrSplit.length > 1) {
      search = attrSplit[1];
    }
    // extract the base url to the href
    base = attrSplit[0];
    // skip link update on same page hash navigation
    if (base) {
      href = base;
      // merge the two search contents. If forceOriginUTM is true, any utm at the links will be overrided
      const noOverrittenParams = {
        cp_landing_term: getCtaId(link),
        cp_landing: getCtaId(link),
      };
      let mergedSearchObj;
      if (config.forceOriginUTM) {
        mergedSearchObj = Object.assign(urlParams, originSearchObj, noOverrittenParams);
      } else {
        mergedSearchObj = Object.assign(originSearchObj, urlParams, noOverrittenParams);
      }
      // transform it back in to a GET url
      search = context.toUrlSearch(mergedSearchObj);
      // append the search url to the base url
      if (search) {
        href += '?' + search;
      }
      // append the hash at the end
      if (hash) {
        href += '#' + hash;
      }
      link.setAttribute(attrName, href);
    }
  }

  context.load = customConfig => {
    // set custom config
    if (typeof customConfig === 'object') {
      config = Object.assign(config, customConfig);
    }

    // stores current location search
    let originSearchObj = Object.assign(config.utmObject, context.extractUrlParams(null));

    // for each link at the page
    for (let link of document.querySelectorAll('[data-utms]')) {
      applyUtmOnAttribute(config, originSearchObj, link, 'href');
    }

    // add the utm values to the forms
    if (config.fillForms) {
      for (let form of document.querySelectorAll('form')) {
        for (let key in originSearchObj) {
          let input = form.querySelector('input[name="' + key + '"]');

          if (input) {
            // override existing input value
            if (config.forceOriginUTM || !input.value) {
              input.value = originSearchObj[key];
            }
          } else {
            // create a new input
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = originSearchObj[key];
            form.appendChild(input);
          }
        }
      }
    }

    if (typeof config.postLoad === 'function') {
      config.postLoad(originSearchObj);
    }
  };
})(utmkeeper);

utmkeeper.load({
  forceOriginUTM: true,
  fillForms: true
});
